import styles from './style.module.scss';
import error404img from '@root/images/errorPage/404.png';

const Error404Page = () => (
  <main>
    <section className={styles.error404}>
      <div className={styles.container}>
        <img src={error404img} alt="ERROR ICON" />
        <div className={styles['error404__text']}>
          <p>Упс...</p>
          <h1>Запрашиваемая страница не найдена</h1>
        </div>
      </div>
    </section>
  </main>
);

export default Error404Page;
